import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import moment from 'moment';
import { Link } from 'react-router-dom';
import {
  Button,
  ButtonsContainer,
  ButtonWithLoader,
  PageWrapper,
  Paper,
  PaperTitle,
  FormWrapper,
  Col,
  InlineFormRow,
  RFFormInput,
  RFFormCheckbox,
  RFFormSelect,
  RFFormRadioGroup,
} from 'virtues-bootstrap';

import { FORM_VALUE_ENGLISH, FORM_VALUE_FRENCH } from 'constants/languages';
import { normalizePatiendId } from 'services/normalize';
import s from './styles.module.scss';
import AdditionalForm from './AdditionalForm';
import Phones from './Phones';

class AddPatient extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    const { pristine, submitting, t, handleSubmit } = this.props;

    return (
      <form onSubmit={handleSubmit} autoComplete="off">
        <PageWrapper tight>
          <Paper className={s.addPatientPaper}>
            <PaperTitle withBorder>{t('addPatient.newPatient')}</PaperTitle>
            <FormWrapper title={t('addPatient.patientInformation')}>
              <InlineFormRow label={t('addPatient.patientId')} labelRequired>
                <Col xs={7}>
                  <Field
                    placeholder="XX-XXXXXX"
                    component={RFFormInput}
                    name="patientId"
                    type="text"
                    normalize={normalizePatiendId}
                  />
                </Col>
              </InlineFormRow>
              <InlineFormRow label={t('addPatient.language')} labelRequired>
                <Col xs={3}>
                  <RFFormRadioGroup
                    groupName="language"
                    radioButtons={[
                      { label: t('addPatient.english'), value: FORM_VALUE_ENGLISH },
                      { label: t('addPatient.french'), value: FORM_VALUE_FRENCH },
                    ]}
                    inline
                  />
                </Col>
              </InlineFormRow>
              <InlineFormRow label={t('addPatient.dob')} labelRequired>
                <Col xs={3}>
                  <Field
                    name="dobMonth"
                    component={RFFormSelect}
                    placeholder={t('addPatient.month')}
                  >
                    {moment.months().map(month => (
                      <option
                        key={month}
                        value={moment()
                          .month(month)
                          .format('MM')}
                      >
                        {month}
                      </option>
                    ))}
                  </Field>
                </Col>
                <Col xs={4}>
                  <Field
                    name="dobYear"
                    component={RFFormInput}
                    placeholder={t('addPatient.year')}
                    maxLength={4}
                  />
                </Col>
              </InlineFormRow>
              <InlineFormRow label={t('addPatient.firstName')} labelRequired>
                <Col xs={7}>
                  <Field placeholder="John" component={RFFormInput} name="firstName" type="text" />
                </Col>
              </InlineFormRow>
              <InlineFormRow label={t('addPatient.lastName')} labelRequired>
                <Col xs={7}>
                  <Field placeholder="Smith" component={RFFormInput} name="lastName" type="text" />
                </Col>
              </InlineFormRow>
              <InlineFormRow label={t('addPatient.phoneNumber')} labelRequired>
                <FieldArray name="patientPhone" component={Phones} />
              </InlineFormRow>
              <InlineFormRow label="">
                <Col xs={7}>
                  <Field
                    component={RFFormCheckbox}
                    name="checkboxContactVia"
                    label={t('addPatient.contactVia')}
                    spaceLg
                  />
                </Col>
              </InlineFormRow>
              <InlineFormRow label={t('addPatient.email')}>
                <Col xs={7}>
                  <Field
                    autoComplete="off"
                    placeholder="johnsmith@email.com"
                    component={RFFormInput}
                    name="email"
                    type="email"
                  />
                </Col>
              </InlineFormRow>
              <InlineFormRow label="">
                <Col xs={7}>
                  <Field
                    component={RFFormCheckbox}
                    name="checkboxRecieve"
                    label={t('addPatient.recieveEmail')}
                    spaceLg
                  />
                </Col>
              </InlineFormRow>
              <InlineFormRow label={t('addPatient.patientPassword')} labelRequired>
                <Col xs={7}>
                  <Field
                    spellCheck={false}
                    className={s.passField}
                    autoComplete="off"
                    component={RFFormInput}
                    name="password"
                    placeholder="••••••••"
                    type="text"
                  />
                </Col>
              </InlineFormRow>
              <InlineFormRow label={t('addPatient.confirmPassword')} labelRequired>
                <Col xs={7}>
                  <Field
                    spellCheck={false}
                    className={s.passField}
                    autoComplete="off"
                    component={RFFormInput}
                    name="confirmPassword"
                    placeholder="••••••••"
                    type="text"
                  />
                </Col>
              </InlineFormRow>
            </FormWrapper>
            <AdditionalForm namePrefix="caregiver" title={t('addPatient.caregiverInformation')} />
            <AdditionalForm namePrefix="alternate" title={t('addPatient.alternateEmergency')} />
          </Paper>
          <ButtonsContainer>
            <Button component={Link} to="/" variant="link">
              {t('buttons.cancel')}
            </Button>
            <ButtonWithLoader disabled={pristine} type="submit" loading={submitting}>
              {t('addPatient.createPatient')}
            </ButtonWithLoader>
          </ButtonsContainer>
        </PageWrapper>
      </form>
    );
  }
}

export default AddPatient;
